import { call, put, takeLatest } from 'redux-saga/effects';
import { userApi } from '../../../api';
import { MODAL } from '../../../constants/params';

import { updateQueryString } from '../../router/actions';

import { getInfo } from '../user/actions';
import { hideUpdateSubscriptionModal, pushNotification } from '../../ui/actions';

import * as actions from './actions';

function* upgradeSubscription({ payload }) {
  try {
    yield put({ type: actions.UPDATE_SUBSCRIPTION_PENDING });
    const { status } = yield call(userApi.updateSubscription, payload);
    if (status === 200) {
      yield put({ type: actions.UPDATE_SUBSCRIPTION_FULFILLED });

      // reload user info
      yield put(getInfo());
      yield put(hideUpdateSubscriptionModal());
      yield put(updateQueryString({ [MODAL]: undefined }));
      yield put(
        pushNotification({
          title: 'Plan upgraded successfully',
          description: 'You can now access all features of the Professional plan',
          type: 'success',
          duration: 0,
        }),
      );
    }
  } catch (e) {
    yield put({ type: actions.UPDATE_SUBSCRIPTION_REJECTED, payload: e });
  }
}

export function* watchUpgradeSubscription() {
  yield takeLatest(actions.UPDATE_SUBSCRIPTION, upgradeSubscription);
}
